import ThreeLineLoading from '../../../components/ui-components/loading/ThreeLineLoading'
import { MFCRedirectionErrorPage } from './MFCRedirectionErrorPage'
import { useMFCRedirection } from '../hooks/useMFCRedirection'

export default function MFCRedirectionAutoPage() {
    const { error, isPending, isSuccess, onTryAgain, onGoToPortfolio } = useMFCRedirection({
        componentTag: 'MFCRedirectionAutoPage',
        uploadOnSuccess: true
    })

    if (error) {
        return (
            <MFCRedirectionErrorPage
                statusCode={error?.code ?? 'unknown'}
                message={error?.message ?? 'Please try again.'}
                onTryAgain={onTryAgain}
                onGoToPortfolio={onGoToPortfolio}
            />
        )
    }

    if (isPending) return <ThreeLineLoading />
    if (isSuccess) return <div className='h-screen overflow-y-scroll no-scrollbar bg-white' />
    return <ThreeLineLoading />
}
